export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="font-heading text-xl font-bold text-background-50 mb-3">
              黑料吃瓜在线
            </div>
            <p className="text-sm text-background-300/50 leading-relaxed mb-4">
              一站式娱乐八卦聚合平台，覆盖娱乐圈、网红圈、综艺圈等 30+ 垂直领域。每日更新 200+ 条黑料吃瓜内容，同步全网热点，让每一次吃瓜都有料。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 hover:bg-background-50/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 hover:bg-background-50/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 hover:bg-background-50/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-background-300/70"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">热搜榜单</a></li>
              <li><a href="#updates" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">实时快讯</a></li>
              <li><a href="#cards" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">专题精选</a></li>
              <li><a href="#media" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">热门视频</a></li>
              <li><a href="#topics" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">热门话题</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">关于我们</h3>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">平台介绍</a></li>
              <li><a href="#contact" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">投稿爆料</a></li>
              <li><a href="#faq" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#features" className="text-sm text-background-300/50 hover:text-background-50 transition-colors cursor-pointer">平台优势</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-300/40 leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质内容平台与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/30 text-center sm:text-left">
            本站内容均来自互联网公开渠道的聚合与整理，仅供娱乐参考，请勿作为事实依据。如涉及侵权或不当内容，请联系我们处理。
          </p>
          <p className="text-xs text-background-300/30 whitespace-nowrap">
            &copy; 2023-2026 黑料吃瓜在线
          </p>
        </div>
      </div>
    </footer>
  );
}